import { gql } from '@apollo/client'

export const GET_APP_CONFIG = gql`
  query GetAppConfig {
    appConfig {
      marketHours {
        startTime
        endTime
      }
      postMaxTextLength
      postMaxLinkTitleLength
      postMaxPhotos
    }
  }
`
